const toNumber = (str: any) => {
  if (/^\d+$/.test(str)) {
    return parseInt(str);
  }
  return str;
};
const coverObjToSelectOption = (obj: any): Array<any> => {
  return Object.keys(obj).map((key) => ({
    value: toNumber(key),
    text: obj[key]
  }));
};

export enum EOptionsSource {
  manual = 1,
  auto = 2
}

export const OptionsSourceStrMap = {
  [EOptionsSource.manual]: '简易',
  [EOptionsSource.auto]: '代码'
}

export interface Option {
  label: string;
  value: string;
  disabled: string;
  hidden: string;
}
export interface AutoOption extends Option{
  dataSource: string;
}

export const optionsSourceOptions = coverObjToSelectOption(OptionsSourceStrMap);
